/**
 * Partes destinatárias de uma publicação do DJEN agrupadas por polo.
 * O DJEN manda o polo como código (A, P…) ou por extenso (AUTOR, RÉU…);
 * o que não for reconhecido vai para "outros" em vez de sumir da ficha.
 */
import type { Destinatario } from '@/types/publication'

export interface PartiesByPole {
  ativo: Destinatario[]
  passivo: Destinatario[]
  outros: Destinatario[]
}

const ACTIVE_CODES = new Set(['A', 'AT', 'ATIVO'])
const ACTIVE_WORDS = ['AUTOR', 'REQUERENTE', 'EXEQUENTE', 'RECORRENTE', 'IMPETRANTE', 'AGRAVANTE', 'EMBARGANTE', 'APELANTE']
const PASSIVE_CODES = new Set(['P', 'R', 'RE', 'PASSIVO'])
const PASSIVE_WORDS = ['RÉU', 'RÉ', 'REU', 'REQUERID', 'EXECUTAD', 'RECORRID', 'IMPETRAD', 'AGRAVAD', 'EMBARGAD', 'APELAD']

export function poleOf(polo: string | null | undefined): keyof PartiesByPole {
  const value = (polo ?? '').toUpperCase().trim()
  if (ACTIVE_CODES.has(value) || ACTIVE_WORDS.some((w) => value.includes(w))) return 'ativo'
  if (PASSIVE_CODES.has(value) || PASSIVE_WORDS.some((w) => value.includes(w))) return 'passivo'
  return 'outros'
}

export function groupPartiesByPole(destinatarios: Destinatario[] | null | undefined): PartiesByPole {
  const groups: PartiesByPole = { ativo: [], passivo: [], outros: [] }
  for (const d of destinatarios ?? []) groups[poleOf(d.polo)].push(d)
  return groups
}
